import { Button } from '@econsult/econsult-ui/dist/components/Button';
import GenericModal from 'components/Modal/GenericModal';
import RichTextEditor from 'components/RichTextEditor';
import React from 'react';
import theme from 'styles/theme';
import { CopilotQueryResponseContainer, CopilotResponseContainer, ResponseButtonContainer } from './styles';

type ResponseModalProps = {
  copilotQueryResponse: string | null | undefined;
  showResponseModal: boolean;
  handleCloseModal: () => void;
  handleReplaceSummary: () => void;
  handleEditCopilotResponse: (editedResponse: string) => void;
};

export const ResponseModal: React.FC<ResponseModalProps> = ({
  showResponseModal,
  handleCloseModal,
  copilotQueryResponse,
  handleReplaceSummary,
  handleEditCopilotResponse,
}) => (
  <GenericModal
    isOpen={showResponseModal}
    onClose={handleCloseModal}
    title="Huma intelligence’s answer..."
    styles={{ background: theme.colorBackgroundSoftWhite }}
    fontStyles={{ fontSize: '16px', fontWeight: 600, color: theme.colorPrimaryPrimary100 }}
    showCloseButton
  >
    <CopilotResponseContainer data-automation="CopilotResponseContainer">
      <CopilotQueryResponseContainer data-automation="CopilotQueryResponseContainer">
        <RichTextEditor
          value={copilotQueryResponse || ''}
          onChange={handleEditCopilotResponse}
          isReadOnly={false}
          showToolbar
        />
      </CopilotQueryResponseContainer>
      <ResponseButtonContainer>
        <Button
          size="small"
          state="primary"
          id="ReplaceSummaryButton"
          onClick={handleReplaceSummary}
          disabled={false}
          data-automation="ReplaceSummaryButton"
          style={{ height: '42px', padding: '0 16px', fontSize: '16px' }}
        >
          Replace summary
        </Button>
      </ResponseButtonContainer>
    </CopilotResponseContainer>
  </GenericModal>
);
